module.exports = __webpack_public_path__ + "img/logo.1465561b.png";